// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fichaMedicaComponentTitle[data-v-52c825d6] {\n  margin-bottom: 15px;\n  font-weight: 500;\n}\n.contraerBox[data-v-52c825d6] {\n  background-color: #f7f9fc;\n  border-radius: 8px;\n  height: 35px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid rgba(0, 0, 0, 0.03);\n  transition: all 0.2s ease;\n}\n.contraerBox[data-v-52c825d6]:hover {\n  background-color: #f0f2f7;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);\n}\n", ""]);
// Exports
module.exports = exports;
